var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-w"},[_c('div',{staticClass:"logo"}),_vm._v(" "),_c('ul',{staticClass:"tab-w"},_vm._l((_vm.tabs),function(i,key){return _c('li',{key:key,staticClass:"tab-l",class:{'teb-sel': _vm.activated === i.to},on:{"click":function($event){return _vm.clickTab(i)}}},[_vm._v(_vm._s(i.title)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4b81626","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/vheader.vue
// module id = null
// module chunks = 